module.exports = __webpack_public_path__ + "static/img/8780_phase_function_Paper_Points.655f7a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8780_phase_function_Paper_Points.png
// module id = 0P+W
// module chunks = 0